/* Product-view events on athlete pages follow the store's separate consent choices. */
(() => {
  'use strict';
  let gaViewed = false;
  let metaViewed = false;
  function trackView() {
    const panel = document.querySelector('[data-athlete-offer]');
    const data = panel?.querySelector('[data-athlete-product]');
    if (!data || window.Shopify?.designMode) return;
    const product = JSON.parse(data.textContent);
    const allowed = kind => window.Shopify?.customerPrivacy?.[kind]?.() === true;
    if (!gaViewed && allowed('analyticsProcessingAllowed') && typeof window.gtag === 'function') {
      gaViewed = true;
      window.gtag('event', 'view_item', { currency: product.currency, value: product.price / 100, items: [{ item_id: String(product.variant), item_name: product.title, quantity: 1 }] });
    }
    if (!metaViewed && allowed('marketingAllowed') && typeof window.fbq === 'function') {
      metaViewed = true;
      window.fbq('track', 'ViewContent', { content_ids: [product.id], content_type: 'product', content_name: product.title, currency: product.currency, value: product.price / 100 });
    }
  }
  trackView();
  document.addEventListener('visitorConsentCollected', trackView);
  window.addEventListener('load', trackView);
  let attempts = 0;
  const timer = setInterval(() => { trackView(); if (++attempts >= 20 || (gaViewed && metaViewed)) clearInterval(timer); }, 250);
})();
